import React, { useState, useEffect } from "react";
import {
  IconButton,
  Typography,
  Box,
  Grid,
  TextField,
  Button,
  Tooltip,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import DeleteOutline from "@mui/icons-material/Delete";
import axios from "axios";
import ImportCSVPopup from "./import-csv-popup";

const Invited = ({
  candidates,
  setRefresh,
  position,
  questions,
  positionId,
  fetchCandidates
}) => {
  const [newCandidate, setNewCandidate] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    prefix: "+91",
    position_id: position ? position?.id : positionId ?? null,
  });
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [openCsv, setOpenCsv] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCandidate({ ...newCandidate, [name]: value });
  };
  const showSnackbar = (msg, type) => {
    setMessage(msg);
    setSeverity(type);
    setOpen(true);
  };
  const deleteCandidate = async (id) => {
    if (!window.confirm("Are you sure you want to delete this candidate?"))
      return;

    try {
      await axios.post(
        "https://api.a2ajobs.com/api/candidate-delete",
        {
          candidate_id: id,
        }
      );

      setRefresh((prev) => !prev);
      showSnackbar("Candidate deleted successfully!", "success");
    } catch (error) {
      console.error(
        "Error deleting candidate:",
        error.response?.data || error.message
      );
      alert("Failed to delete candidate!");
    }
  };
  const validate = () => {
    const errs = {};
    if (!newCandidate.first_name.trim())
      errs.first_name = "First name is required";
    if (!newCandidate.last_name.trim())
      errs.last_name = "Last name is required";
    if (!newCandidate.email.trim()) {
      errs.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(newCandidate.email)) {
      errs.email = "Email is invalid";
    }
    // if (!newCandidate.phone.trim()) {
    //     errs.phone = "Phone number is required";
    // } else if (!/^\d{6,15}$/.test(newCandidate.phone)) {
    //     errs.phone = "Phone number must be between 8 and 15 digits";
    // }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const inviteCandidate = async () => {
    const isDuplicate = candidates.some(
      (c) => c.email.toLowerCase() === newCandidate.email.toLowerCase()
    );

    if (isDuplicate) {
      showSnackbar(
        "This candidate has already been invited for this position!",
        "error"
      );
      return;
    }
    setLoading(true);
    try {
      const formattedCandidate = {
        ...newCandidate,
        phone: parseInt(newCandidate.phone, 10),
        invited_at: new Date().toISOString(),
      };

      await axios.post(
        "https://api.a2ajobs.com/api/candidate-create",
        formattedCandidate,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      setNewCandidate({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        position_id: position?.id,
      });
      setRefresh((prev) => !prev);
      showSnackbar("Candidate invited successfully!", "success");
    } catch (error) {
      console.error(
        "Error inviting candidate:",
        error.response?.data || error.message
      );
      showSnackbar("Failed to invite candidate!", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleCopy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => showSnackbar("Link copied to clipboard!", "success"))
      .catch((err) => console.error("Failed to copy: ", err));
  };
  const baseURL =
    window.location.origin || "https://uiwebsite.schoolmgmtsys.com";

  return (
    <>
      <Box mt={3} p={2} sx={{ backgroundColor: "#fff", borderRadius: 2 }}>
        <Typography fontSize={25} fontWeight={600}>
          Candidate Information
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              placeholder="First Name"
              name="first_name"
              value={newCandidate.first_name}
              onChange={handleInputChange}
              error={!!errors.first_name}
              helperText={errors.first_name}
            />{" "}
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              placeholder="Last Name"
              name="last_name"
              value={newCandidate.last_name}
              onChange={handleInputChange}
              error={!!errors.last_name}
              helperText={errors.last_name}
            />{" "}
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              placeholder="Email"
              name="email"
              value={newCandidate.email}
              onChange={handleInputChange}
              error={!!errors.email}
              helperText={errors.email}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              placeholder="Mobile Phone"
              name="phone"
              value={newCandidate.phone}
              onChange={handleInputChange}
              error={!!errors.phone}
              helperText={errors.phone}
            />{" "}
          </Grid>
          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{
                textTransform: "none",
                borderRadius: "6px",
                bgcolor: "#1666EB",
              }}
              onClick={() => {
                if (validate()) {
                  inviteCandidate();
                }
              }}
              disabled={loading}
              startIcon={
                loading && <CircularProgress color="inherit" size={20} />
              }
            >
              {loading ? "Inviting..." : "Invite Candidate"}
            </Button>
          </Grid>
          <Grid item xs={12} md={2}>
            <Typography
              color="primary"
              sx={{ "&:hover": { cursor: "pointer" } }}
              onClick={() => setOpenCsv(true)}
            >
              {" "}
              Or Import from a file
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box mt={3}>
        {candidates?.length > 0 ? (
          candidates?.map((candidate) => (
            <Box
              key={candidate.id}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              p={2}
              mb={2}
              sx={{
                border: "1px solid #ddd",
                borderRadius: 2,
                backgroundColor: "#fff",
                flexWrap: "wrap",
                gap: { md: 0, xs: 2 },
              }}
            >
              <Box>
                <Typography fontWeight="bold">{`${candidate.first_name} ${candidate.last_name}`}</Typography>
                <Typography variant="body2">{candidate.phone}</Typography>
                <Typography variant="body2" color="primary">
                  {candidate.email}
                </Typography>
                <Tooltip title="Copy" arrow>
                  <Typography
                    variant="body2"
                    sx={{ "&:hover": { cursor: "pointer" } }}
                    onClick={() => {
                      const queryString = new URLSearchParams({
                        url_id: candidate.url_id,
                        // candidateName: `${candidate.first_name} ${candidate.last_name}`,
                        positionId: position?.id || positionId,
                      }).toString();

                      handleCopy(`${baseURL}/#/interview?${queryString}`);
                    }}
                  >
                    {`${baseURL}/#/interview?url_id=${candidate.url_id}&positionId=${positionId}`}
                  </Typography>
                </Tooltip>
              </Box>
              <Box sx={{ textAlign: { md: "end", xs: "start" } }}>
                <Typography>{candidate?.human_date}</Typography>
                <IconButton
                  color="error"
                  onClick={() => deleteCandidate(candidate.id)}
                >
                  <DeleteOutline />
                </IconButton>
              </Box>
            </Box>
          ))
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="300px"
          >
            <Typography variant="h3" color="gray">
              Invited candidates.
            </Typography>
            <Typography variant="h6" color="gray">
              {" "}
              There are no candidates pending to complete their interview.
            </Typography>
          </Box>
        )}
      </Box>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={severity}
          variant="filled"
        >
          {message}
        </Alert>
      </Snackbar>
      <ImportCSVPopup
        open={openCsv}
        handleClose={() => setOpenCsv(false)}
        positionId={position?.id || positionId}
        onImportSuccess={fetchCandidates}
      />
    </>
  );
};

export default Invited;